
const CL_MAINTAIN_BAYROL = `{.NO_REGUL_AND_NO_ELEC}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l avec {{#OR_SEP}}CL_LONG_PRODUCTS_BAYROL{{/OR_SEP}}

{.USE_REGUL_AND_CHLORE}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l en ajustant la valeur de consigne de l'appareil 

{.USE_ELEC_NO_REGUL}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur.

{.USE_ELEC_AND_REGUL}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur ou la valeur de consigne de l’appareil.` ;

const CL_MAINTAIN_AQUAPURE = `{.NO_REGUL_AND_NO_ELEC}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l avec {{#OR_SEP}}CL_LONG_PRODUCTS_AQUAPURE{{/OR_SEP}}

{.USE_REGUL_AND_CHLORE}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l en ajustant la valeur de consigne de l'appareil 

{.USE_ELEC_NO_REGUL}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur.

{.USE_ELEC_AND_REGUL}
Puis maintenir le taux de chlore entre 0.5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur ou la valeur de consigne de l’appareil.` ;


const BR_MAINTAIN_BAYROL = `Puis maintenir le taux de brome entre 1 et 3 mg/L avec *Aquabrome®* en réglant la vanne du brominateur ou en ajustant la valeur de consigne de l'appareil.`
const BR_MAINTAIN_AQUAPURE = `Puis maintenir le taux de brome entre 1 et 3 mg/L avec *Brome Pastilles AquaPure* en réglant la vanne du brominateur ou en ajustant la valeur de consigne de l'appareil.`

const BLOCKS = {
    FILTRATION :    { 
        title: "Température d'eau : {{temp}}°C", 
        text: "Filtrer au minimum {{xt1}} par jour",
    },
    REGUL1 :        { 
        title: "Régulation automatique", 
        text: "Avant une désinfection choc ou un ajustement manuel du pH,  arrêter/débrancher l'appareil ; attendre 24 à 48H avant de le redémarrer"
    },
    SEL :           { 
        title: "Taux de sel faible", 
        text: `Sel - {{xsel}} 

Arrêter l'électrolyseur puis ajouter le sel uniformément dans l'eau du bassin. Attendre 72 heures avant de remettre en fonctionnement l'appareil`
    },
    TH1 :           { 
        title: "Dureté élevée", 
        text: "",
        catalogs: {
            BAYROL: { products: ["CALCINEX"] },
            AQUAPURE: { products: ["ANTICALCAIRE_AQUAPURE"] }
        }
    },
    TH2 :           { 
        title: "Dureté faible", 
        text: "",
        catalogs: {
            BAYROL: { text: "Demandez conseil à votre revendeur . L'utilisation de *Chloryte* lors des traitements choc peut aider à augmenter la dureté de l'eau." },
            AQUAPURE: { text: "Demandez conseil à votre revendeur . L'utilisation d'un produit à base d'*hypochlorite de calcium* lors des traitements choc peut aider à augmenter la dureté de l'eau." }
        }
    },
    TAC2 :          { 
        title: "Alcalinité (TAC) faible", 
        text: `{.ALK_VERY_LOW}
Le TAC étant très faible, ne pas ajouter plus de {{maxtac}} à la fois. Attendre 4 à 6 heures entre chaque apport, filtration en fonctionnement.`,
        catalogs: {
            BAYROL: {  products: ["ALCAPLUS"],  },
            AQUAPURE: {  products: ["ALCAFIX_AQUAPURE"], }
        }
    },
    PH1 :           { 
        title: "pH faible", 
        text: `{.PH_VERY_LOW}
Le pH étant très faible, ne pas ajouter plus de {{maxph+}} à la fois. Attendre 3 à 4 Heures entre chaque ajout, filtration en fonctionnement`,
        catalogs: {
            BAYROL: {  products: ["PH_PLUS"],  },
            AQUAPURE: {  products: ["PH_PLUS_AQUAPURE"], }
        }
    },
    PH2 :           { 
        title: "pH élevé", 
        text: `{.PH_VERY_HIGH}
Le pH étant très élevé, ne pas ajouter plus de {{maxph-}} à la fois. Attendre 3 à 4 Heures entre chaque ajout, filtration en fonctionnement`,
        catalogs: {
            BAYROL: {  products: ["PH_MINUS"],  },
            AQUAPURE: {  products: ["PH_MINUS_AQUAPURE"], }
        }
    },
    PH4 :           { 
        title: "pH faible", 
        text: `{.PH_VERY_LOW}
Le pH étant très faible, ne pas ajouter plus de {{maxph+}} à la fois. Attendre 3 à 4 Heures entre chaque ajout, filtration en fonctionnement`,
        catalogs: {
            BAYROL: {  products: ["PH_PLUS"],  },
            AQUAPURE: {  products: ["PH_PLUS_AQUAPURE"], }
        }
    },
    PH5 :           { 
        title: "pH élevé", 
        text: `{.PH_VERY_HIGH}
Le pH étant très élevé, ne pas ajouter plus de {{maxph-}} à la fois. Attendre 3 à 4 Heures entre chaque ajout, filtration en fonctionnement`,
        catalogs: {
            BAYROL: {  products: ["PH_MINUS"],  },
            AQUAPURE: {  products: ["PH_MINUS_AQUAPURE"], }
        }
    },
    PH7 :           { 
        title: "pH faible", 
        text: `L'augmentation du TAC devrait augmenter le pH.  48 heures après ajustement du TAC, contrôler le pH et le réajuster si besoin dans la zone recommandée.`
    },
    PH8 :           { 
        title: "pH correctement ajusté", 
        text: `L'augmentation du TAC devrait augmenter le pH.  48 heures après ajustement du TAC, contrôler le pH et le réajuster si besoin dans la zone recommandée.`
    },
    PH9 :           { 
        title: "pH élevé", 
        text: `L'augmentation du TAC devrait encore augmenter le pH.  48 heures après ajustement du TAC, contrôler le pH et le réajuster dans la zone recommandée.`
    },
    PH10 :          { 
        title: "pH correctement ajusté", 
        text: `L'augmentation du TAC devrait augmenter le pH.  48 heures après ajustement du TAC, contrôler le pH et le réajuster si besoin dans la zone recommandée.`
    },
    PH11 :          { 
        title: "pH élevé", 
        text: `L'augmentation du TAC devrait encore augmenter le pH.  48 heures après ajustement du TAC, contrôler le pH et le réajuster dans la zone recommandée.`
    },
    CL1 :          { 
        title: "Taux de chlore faible", 
        text: "",
        catalogs: {
            BAYROL: {  products: ["CHLORIKLAR", "CHLORIFIX", "CHLORYTE"], text: CL_MAINTAIN_BAYROL },
            AQUAPURE: {  products: ["CHLORE_CHOC_PASTILLE_AQUAPURE", "CHLORE_RAPIDE_GRANULES_AQUAPURE"], text: CL_MAINTAIN_AQUAPURE }
        }
    },
    CL3 :           { 
        title: "Taux de chlore élevé", 
        text: "",
        catalogs: {
            BAYROL: {  text: "Attendre que le taux de chlore soit inférieur à 1,5 mg/l avant de rajouter du chlore\n\n"+CL_MAINTAIN_BAYROL },
            AQUAPURE: {  text: "Attendre que le taux de chlore soit inférieur à 1,5 mg/l avant de rajouter du chlore\n\n"+CL_MAINTAIN_AQUAPURE }
        }
    },
    CL4 :           { 
        title: "Taux de chlore très élevé", 
        text: "",
        catalogs: {
            BAYROL: {  text: "Sauf si traitement de choc très récent,  neutraliser le chlore selon les recommandations de votre revendeur.\n\n"+CL_MAINTAIN_BAYROL },
            AQUAPURE: {  text: "Sauf si traitement de choc très récent,  neutraliser le chlore selon les recommandations de votre revendeur.\n\n"+CL_MAINTAIN_AQUAPURE }
        }
    },
    CL6 :           { 
        title: "Concentration en chloramines importante", 
        text: `Renouveler de l'eau ou effectuer une chloration choc selon les conseils de votre revendeur`
    },
    BR1 :           { 
        title: "Taux de brome faible", 
        text: "",
        catalogs: {
            BAYROL: {  products: ["AQUABROME_REGENERATOR", "CHLORYTE"], text: BR_MAINTAIN_BAYROL },
            AQUAPURE: {  products: ["OXYDANT_CHOC_AQUAPURE"], text: BR_MAINTAIN_AQUAPURE }
        }
    },
    BR3 :           { 
        title: "Taux de brome élevé", 
        text: "Attendre que la concentration soit inférieure à 1.5 mg/L avant de rajouter du brome.",
        catalogs: {
            BAYROL: { text: BR_MAINTAIN_BAYROL },
            AQUAPURE: {  text: BR_MAINTAIN_AQUAPURE }
        }
    },
    BR4 :           { 
        title: "Taux de brome très élevé", 
        text: "Sauf si traitement de choc très récent,  neutraliser le brome selon les recommandations de votre revendeur.",
        catalogs: {
            BAYROL: { text: BR_MAINTAIN_BAYROL },
            AQUAPURE: {  text: BR_MAINTAIN_AQUAPURE }
        }
    },
    STAB2 :         { 
        title: "Stabilisant de chlore élevé", 
        text: `Un renouvellement d’eau est conseillé ; demandez conseil à votre revendeur`
    },
    STAB4 :         { 
        title: "Stabilisant de chlore élevé", 
        text: `Un renouvellement d’eau est conseillé ; demandez conseil à votre revendeur`
    },
    FER2 :          { 
        title: "Présence de Fer", 
        catalogs: {
            BAYROL: {  products: ["SUPERFLOCK_PLUS", "CALCINEX"], text: `{.FILTER_GLASS_OR_SAND}
Afin d'éliminer le Fer via le Superflock plus, le pH doit être ajusté entre 7.0 et 7.4.` },
            AQUAPURE: {  products: ["SUPERFLOCK_PLUS", "ARRET_METAL_AQUAPURE"], text: `{.FILTER_GLASS_OR_SAND}
Afin d'éliminer le Fer via le Superflock plus, le pH doit être ajusté entre 7.0 et 7.4.` }
        }
    },
    CU2 :          { 
        title: "Présence de Cuivre", 
        catalogs: {
            BAYROL: {  products: ["SUPERFLOCK_PLUS", "CALCINEX"], text: `{.FILTER_GLASS_OR_SAND}
Afin d'éliminer le Cuivre via le Superflock plus, le pH doit être ajusté entre 7.5 et 7.8.` },
            AQUAPURE: {  products: ["SUPERFLOCK_PLUS", "ARRET_METAL_AQUAPURE"], text: `{.FILTER_GLASS_OR_SAND}
Afin d'éliminer le Cuivre via le Superflock plus, le pH doit être ajusté entre 7.5 et 7.8.` }
        }
    },
    PHOSPHATE2 :    { 
        title: "Présence de phosphate", 
        text: `Contrôler le taux plusieurs jours après et renouveler le dosage si besoin`,
        catalogs: {
            BAYROL: {  products: ["NOPHOS"] },
            AQUAPURE: {  products: ["NOPHOS"] }
        }
    },
    RECO1 : {
        title: " - ",
        text: `Filtrer tous les jours pour un temps minimum égal à la température de l'eau /2`
    },
    RECO2 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: {  text: `Ajouter {{x1}} de *Calcinex®* au démarrage de la saison pour éviter l’apparition de calcaire.` },
            AQUAPURE: {  text: `Ajouter {{a1}} d'*Anticalcaire AquaPure* au démarrage de la saison pour éviter l’apparition de calcaire.` }
        }
    },
    RECO3 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: {  text: `Désinfecter le filtre avec {{x17}} de *Filterclean tab* en début de saison` },
            AQUAPURE: {  text: `Désinfecter le filtre avec {{x17}} de *Filterclean tab* en début de saison` },
        }
    },
    RECO4 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: {  text: `Vérifier une à deux fois par semaine le pH et adapter le dosage de  *pH-Minus* ou *pH-Plus* pour le maintenir {{targetPHzone}}` },
            AQUAPURE: {  text: `Vérifier une à deux fois par semaine le pH et adapter le dosage de  *pH-Minus Aquapure* ou *pH-Plus Aquapure* pour le maintenir {{targetPHzone}}` },
        }
    },
    RECO5 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: {  text: `Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l avec {{#OR_SEP}}CL_LONG_PRODUCTS_BAYROL{{/OR_SEP}}. {.NO_REGUL_AND_NO_ELEC}
            
            Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l en ajustant la valeur de consigne de l'appareil. {.USE_REGUL_AND_CHLORE}
            
            Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur. {.USE_ELEC_NO_REGUL}
            
            Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur ou la valeur de consigne de l’appareil. {.USE_ELEC_AND_REGUL}` },
            AQUAPURE: {  text: `Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l avec {{#OR_SEP}}CL_LONG_PRODUCTS_AQUAPURE{{/OR_SEP}} {.NO_REGUL_AND_NO_ELEC}
            
            Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l en ajustant la valeur de consigne de l'appareil. {.USE_REGUL_AND_CHLORE}
            
            Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur. {.USE_ELEC_NO_REGUL}

            Mesurer le taux de chlore au moins une fois par semaine et le maintenir entre 0,5 et 2 mg/l en ajustant la production de chlore de l'électrolyseur ou la valeur de consigne de l’appareil. {.USE_ELEC_AND_REGUL}` },
        }
    },
    RECO6 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL : { text : `Mesurer le taux de brome au moins une fois par semaine et le maintenir entre 1 et 3 mg/ avec *Aquabrome®*
            
            {.NO_REGUL}
            en réglant la vanne du brominateur   
            
            {.USE_REGUL}
            en ajustant la valeur de consigne de l'appareil.` },
            AQUAPURE : { text : `Mesurer le taux de brome au moins une fois par semaine et le maintenir entre 1 et 3 mg/ avec *Brome Pastilles AquaPure*
            
            {.NO_REGUL}
            en réglant la vanne du brominateur   
            
            {.USE_REGUL}
            en ajustant la valeur de consigne de l'appareil.` },
        }
    },
    RECO7 : {
        title: " - ",
        text: `Pour un bon traitement, ajouter chaque semaine {{#OR_SEP}}O2_LONG_PRODUCTS_BAYROL{{/OR_SEP}}.
        En cas de température d'eau élevée, augmenter le dosage.`
    },
    RECO8 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Chaque semaine ajouter {{#OR_SEP}}ALG_PRODUCTS_BAYROL{{/OR_SEP}}` },
            AQUAPURE: { text: `Chaque semaine ajouter {{#OR_SEP}}ALG_PRODUCTS_AQUAPURE{{/OR_SEP}}` },
        }
    },
    RECO9 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `{.FILTER_GLASS_OR_SAND}
            Clarifier l’eau chaque semaine avec {{x5}} de *Superflock plus*
            
            {.FILTER_CART}
            Clarifier l’eau chaque semaine avec {{x16}} de *Superklar*` },
            AQUAPURE: { text: `{.FILTER_GLASS_OR_SAND}
            Clarifier l’eau chaque semaine avec {{a22}} *Floculant cartouches AquaPure*
            
            {.FILTER_CART}
            Clarifier l’eau chaque semaine avec {{x16}} de *Superklar*` },
        }
    },
    RECO10 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Nettoyer la ligne d’eau régulièrement avec *Bordnet ou Protect & Clean*` },
            AQUAPURE: { text: `Nettoyer la ligne d’eau régulièrement avec *Nettoyant Ligne D'eau AquaPure* ou *Net' Bord Gel Acide AquaPure*` },
        }
    },
    RECO11 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Pour maintenir votre ligne d’eau et les skimmers propres plus longtemps, ajouter {{x36}} de  *Protect & Shine*` },
            AQUAPURE: { text: `Pour maintenir votre ligne d’eau et les skimmers propres plus longtemps, ajouter {{x36}} de  *Protect & Shine*` },
        }
    },
    RECO12 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Avant l’hivernage du bassin, détartrer le filtre avec *Decalcit Filtre*` },
            AQUAPURE: { text: `Avant l’hivernage du bassin, détartrer le filtre avec *Détartrant Filtre AquaPure*` },
        }
    },
    RECO13 : {
        title: " - ",
        text: `Renouveler au minimum un tiers de l’eau chaque année.`
    },
    RECO14 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Chaque année, détartrer la cellule de l'électrolyseur avec *Cell Renov*`},
            AQUAPURE: { text: `Chaque année, détartrer la cellule de l'électrolyseur avec *Détartrant Cellule AquaPure*`},
        }
    },
    ALG1: {
        title: " - ",
        text: `Brosser les parois, le fond du bassin et nettoyer les paniers de skimmer`,
    },
    ALG2 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Laver le filtre et le détartrer  avec *Decalcit Filtre* si cela n'a pas été fait à l'hivernage précédent`},
            AQUAPURE: { text: `Laver le filtre et le détartrer  avec *Détartrant Filtre AquaPure* si cela n'a pas été fait à l'hivernage précédent`},
        }
    },
    ALG3 : {
        title: " - ",
        text: `Mettre en fonctionnement la filtration 24H/24 jusqu'à ce que l'eau redevienne cristalline`,
    },
    ALG4 : {
        title: " - ",
        text: `Si besoin, ajuster le pH dans la zone recommandée selon les indications mentionnées dans la partie supérieure`,
    },
    ALG5 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Effectuer un traitement de choc avec : {{#OR_SEP}}CL_SHOCK_PRODUCTS_BAYROL{{/OR_SEP}}. {.CHLORINE}
            
            Effectuer un traitement de choc avec : {{#OR_SEP}}BR_SHOCK_PRODUCTS_BAYROL{{/OR_SEP}}. {.BROMINE}

            Effectuer un traitement de choc avec : {{#OR_SEP}}O2_SHOCK_PRODUCTS_BAYROL{{/OR_SEP}}. {.O2} `},
            AQUAPURE: { text: `Effectuer un traitement de choc avec : {{#OR_SEP}}CL_SHOCK_PRODUCTS_AQUAPURE{{/OR_SEP}}. {.CHLORINE}
            
            Effectuer un traitement de choc avec : {{#OR_SEP}}BR_SHOCK_PRODUCTS_AQUAPURE{{/OR_SEP}}. {.BROMINE}

            Effectuer un traitement de choc avec : {{#OR_SEP}}O2_SHOCK_PRODUCTS_AQUAPURE{{/OR_SEP}}. {.O2} `},
        }
    },
    ALG6 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Si revêtement carrelage, éliminer les algues avec *X 100*`},
            AQUAPURE: { text: `Si revêtement carrelage, éliminer les algues avec *Chlore Granulés 90 % AquaPure*`},
        }
    },
    ALG7 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Ajouter {{x38}} de *Desalgine®* ou {{x39}} de *Desalgine® Jet*`},
            AQUAPURE: { text: `Ajouter {{a27}} de *Anti-Algue AquaPure* ou {{a28}} de *Anti-Algue Multi-Actions AquaPure*`},
        }
    },
    ALG8 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Clarifier l’eau avec {{x5}} de *Superflock plus*. {.FILTER_GLASS_OR_SAND}

            Clarifier l’eau avec {{x16}} de *Superklar*. {.FILTER_CART}`},
            AQUAPURE: { text: `Clarifier l’eau avec {{a22}} *Floculant cartouches AquaPure*. {.FILTER_GLASS_OR_SAND}

            Clarifier l’eau avec {{x16}} de *Superklar*. {.FILTER_CART}`},
        }
    },
    ALG9 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Après destruction des algues, contrôler de nouveau les phosphates et ajouter *Nophos* si nécessaire`},
            AQUAPURE: { text: `Après destruction des algues, contrôler de nouveau les phosphates et ajouter *Nophos* si nécessaire`},
        }
    },
    TROUBLED1 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Laver le filtre et le détartrer  avec *Decalcit Filtre* si cela n'a pas été fait à l'hivernage précédent`},
            AQUAPURE: { text: `Laver le filtre et le détartrer  avec *Détartrant Filtre AquaPure* si cela n'a pas été fait à l'hivernage précédent`},
        }
    },
    TROUBLED2 : {
        title: " - ",
        text: `Mettre en fonctionnement la filtration 24H/24 jusqu'à ce que l'eau redevienne cristalline`,
    },
    TROUBLED3 : {
        title: " - ",
        text: `Si besoin, ajuster le pH dans la zone recommandée selon les indications mentionnées dans la partie supérieure`,
    },
    TROUBLED4 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Effectuer un traitement de choc avec : {{#OR_SEP}}CL_SHOCK_PRODUCTS_BAYROL{{/OR_SEP}}. {.CHLORINE}
            
            Effectuer un traitement de choc avec : {{#OR_SEP}}BR_SHOCK_PRODUCTS_BAYROL{{/OR_SEP}}. {.BROMINE}

            Effectuer un traitement de choc avec : {{#OR_SEP}}O2_SHOCK_PRODUCTS_BAYROL{{/OR_SEP}}. {.O2} `},
            AQUAPURE: { text: `Effectuer un traitement de choc avec : {{#OR_SEP}}CL_SHOCK_PRODUCTS_AQUAPURE{{/OR_SEP}}. {.CHLORINE}
            
            Effectuer un traitement de choc avec : {{#OR_SEP}}BR_SHOCK_PRODUCTS_AQUAPURE{{/OR_SEP}}. {.BROMINE}

            Effectuer un traitement de choc avec : {{#OR_SEP}}O2_SHOCK_PRODUCTS_AQUAPURE{{/OR_SEP}}. {.O2} `},
        }
    },
    TROUBLED5 : {
        title: " - ",
        text: ``,
        catalogs: {
            BAYROL: { text: `Clarifier l’eau avec {{x5}} de *Superflock plus* ou avec *Quickflock Super*. {.FILTER_GLASS_OR_SAND}

            Clarifier l’eau avec {{x16}} de *Superklar*. {.FILTER_CART}`},
            AQUAPURE: { text: `Clarifier l’eau avec {{a22}} *Floculant cartouches AquaPure*  ou avec *Floculant AquaPure*. {.FILTER_GLASS_OR_SAND}

            Clarifier l’eau avec {{x16}} de *Superklar*. {.FILTER_CART}`},
        }
    }
}

module.exports = BLOCKS;